import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';

import { logout } from '../../actions/sessionActions';
import logoHeader from '../../assets/logo_sinfondo2016.png';
import { usersLinks } from '../../constants/constants';
import '../../styles/header.scss';

const Header = ({ userType, logout }) => (
  <Navbar collapseOnSelect>
    <Navbar.Header>
      <Navbar.Brand>
        <Link to="/">
          <img alt="logo" src={logoHeader} />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
    <Navbar.Collapse>
      <Nav>
        { userType &&
          usersLinks[userType.toLowerCase()].map((link, index) =>
            <LinkContainer to={link.path} key={index}>
              <NavItem>{link.label}</NavItem>
            </LinkContainer>
          )
        }
      </Nav>
      <Nav pullRight>
        <LinkContainer to="/perfil">
          <NavItem>MI PERFIL</NavItem>
        </LinkContainer>
        <NavItem onClick={logout}>SALIR</NavItem>
      </Nav>
    </Navbar.Collapse>
  </Navbar>
);

const { string, func } = PropTypes;

Header.propTypes = {
  logout: func.isRequired,
  userType: string.isRequired
};

const mapState = state => ({
  userType: state.getIn(['session', 'user', 'type'])
});

const mapDispatch = dispatch => ({
  logout: () => dispatch(logout())
});

export default connect(mapState, mapDispatch, null, { pure: false })(Header);



// WEBPACK FOOTER //
// ./src/components/common/Header.js